import myAxios from "@/utils/request";
export default {
  getList(params) {
    return myAxios.post("/api/achievement/achipaging_rtat", params);
  },
  beforeBatchDelete(params) {
    return myAxios.post("/api/achievement/achiexistproject", params);
  },
  batchDelete(params) {
    return myAxios.post("/api/achievement/backbatchdelete", params);
  },
  // 添加/修改技术成果详情
  addTechAch(params) {
    return myAxios.post("/api/achievement/topaddachi_im", {
      ...params,
      type: 1
    });
  },
  // 添加/修改产品成果详情
  addProdAch(params) {
    return myAxios.post("/api/achievement/topaddachi_im", {
      ...params,
      type: 2
    });
  },
  // 审核成果详情
  auditAch(params) {
    return myAxios.post("/api/achievement/approveachi_im", params);
  },
  // 获取成果详细信息
  getAchInfo(params) {
    const { id } = params;
    return myAxios.get("/api/achievement/getachibyid_im?id=" + id);
  }
};
